export class MoopsyRequest {
    constructor(message, requireAuth, 
    /**
     * Whether this request will be preserved and retried following a reconnection
     * Should typically be true for mutations and false for queries
     */
    surviveReconnection) {
        this.message = message;
        this.requireAuth = requireAuth;
        this.surviveReconnection = surviveReconnection;
    }
}
